import { Copy } from 'lucide-react';
import React, { useCallback, useState } from 'react';
import { copyToClipboard } from 'utils/proxyUtils';
import Button from '../Button';
import Popover from '../Popover';

type CopyButtonProps = {
    text: string,
    portal?: boolean,
    variant?: "primary" | "secondary" | "link" | "muted" | "destructive" | "muted-destructive" | "destructive-outline" | "outline" | "ghost" | null | undefined,
    size?: "link" | "icon" | "sm" | "md" | "lg" | "xl" | null | undefined,
    buttonText?: string,
    icon?: React.ReactNode,
    tooltip?: string,
    className?: string,
    tooltipSide?: 'top' | 'right' | 'bottom' | 'left',
    tooltipAlign?: 'start' | 'center' | 'end',
}

const CopyButton = ({
    portal = true,
    text, tooltip, tooltipAlign, tooltipSide, className, variant = 'primary', size = 'icon', buttonText, icon = <Copy size={18} /> }: CopyButtonProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleCopy = useCallback(async () => {
        try {
            await copyToClipboard(text);
            setIsOpen(true);
            setTimeout(() => setIsOpen(false), 1000);
        } catch (error) {
            console.error('Failed to copy:', error);
        }
    }, [text]);

    return (
        <Popover open={isOpen} onOpenChange={setIsOpen}>
            <Popover.Trigger asChild>
                <Button
                    variant={variant}
                    size={size}
                    onClick={handleCopy}
                    className={className}
                    tooltip={tooltip}
                    tooltipSide={tooltipSide}
                    tooltipAlign={tooltipAlign}
                >
                    {icon}
                    <span className="">{buttonText}</span>
                </Button>
            </Popover.Trigger>
            <Popover.Content className="w-fit p-2" portal={portal} container={document.getElementById('root-atarim')?.shadowRoot?.getElementById('app-wrapper') || document.body}>
                <span>Copied!</span>
            </Popover.Content>
        </Popover>
    );
};

export default CopyButton;
